import React from "react";
import {Brands} from "@core-ui/utility";
import {Icon} from "../components/Icon";
import {IconContainerProps} from "../types";

const CrossBrandSVG = (
  <svg viewBox="0 0 33 33" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.117.402c.659.33 1.193.864 1.522 1.522l12.597 25.194a3.403 3.403 0 01-3.044 4.925H4a3.403 3.403 0 01-3.044-4.925L13.552 1.924A3.403 3.403 0 0118.117.402zm-1.516 23.156c-1.393 0-2.436 1.047-2.436 2.445 0 1.39 1.045 2.434 2.436 2.434s2.426-1.044 2.426-2.434c0-1.398-1.032-2.445-2.426-2.445zm2.02-14.565h-4.05v12.186h4.05V8.993z"
      fill="#F0B00B"
      fillRule="nonzero"
    />
  </svg>
);

const brandIconSVGs = {
  [Brands.Athleta]: CrossBrandSVG,
  [Brands.BananaRepublic]: CrossBrandSVG,
  [Brands.BananaRepublicFactoryStore]: CrossBrandSVG,
  [Brands.Gap]: CrossBrandSVG,
  [Brands.GapFactoryStore]: CrossBrandSVG,
  [Brands.OldNavy]: CrossBrandSVG,
  crossBrand: CrossBrandSVG,
};

export const NotificationWarningIcon = (
  props: IconContainerProps
): JSX.Element => <Icon {...props} brandIconSVGs={brandIconSVGs} />;
